document.addEventListener("DOMContentLoaded", () => {

  const buttons = document.querySelectorAll(".winter-btn");

  buttons.forEach(button => {

    button.addEventListener("mouseenter", () => {
      button.classList.add("is-hover");
    });

    button.addEventListener("mouseleave", () => {
      button.classList.remove("is-hover");
    });

  });

});